export async function writeEncryptedExcel(workbookArray, password, fileName) {
  const XlsxPopulate = (await import('xlsx-populate/browser/xlsx-populate.min.js')).default;
  const workbook = await XlsxPopulate.fromDataAsync(workbookArray);
  const blob = await workbook.outputAsync({ password: password });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
